import { create } from 'zustand';
import type { MobileView } from './regional-overview.models';

interface RegionalOverviewStoreValues {
  hasShiftData: boolean;
  isDemo: boolean;
  mobileView: MobileView;
}

interface RegionalOverviewStoreFunctions {
  setHasShiftData: (hasShiftData: boolean) => void;
  setIsDemo: (isDemo: boolean) => void;
  setMobileView: (mobileView: MobileView) => void;
}

type RegionalOverviewStore = RegionalOverviewStoreValues & RegionalOverviewStoreFunctions;

export const useRegionalOverviewStore = create<RegionalOverviewStore>(set => ({
  hasShiftData: false,
  isDemo: false,
  mobileView: 'map',

  setHasShiftData: hasShiftData => set({ hasShiftData }),
  setIsDemo: isDemo => set({ isDemo }),
  setMobileView: mobileView => set({ mobileView })
}));
